import { Link } from "react-router-dom";

const Logo = ({ size = "md", showText = true, className = "" }) => {
  const sizes = {
    sm: "h-7 w-7",
    md: "h-9 w-9",
    lg: "h-12 w-12",
  };
  return (
    <Link
      to="/"
      data-testid="brand-logo-link"
      className={`flex items-center gap-2.5 group ${className}`}
    >
      <div className={`relative ${sizes[size]} shrink-0`}>
        <img
          src="/assets/vts-logo.jpeg"
          alt="VTS — Forex, Gold & Crypto Trading Desk"
          className="h-full w-full object-contain rounded-full"
        />
        <div className="absolute inset-0 rounded-full ring-1 ring-vts-blue/30 group-hover:ring-vts-blue/70 transition" />
      </div>
      {showText && (
        <div className="flex flex-col leading-none">
          <span className="font-heading font-bold text-base tracking-tight text-white">
            VTS
          </span>
          <span className="text-[9px] sm:text-[10px] uppercase tracking-[0.18em] text-vts-silver/70 whitespace-nowrap">
            Forex · Gold · Crypto
          </span>
        </div>
      )}
    </Link>
  );
};

export default Logo;
